var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCbsLacenIconApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 92.5 92.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-35c35904-e07c-400a-96c1-2110f81066f7{fill:#fff;}.uuid-c6b517c4-f947-453c-9c35-63b54d5b797d{fill:url(#uuid-f801671d-40ef-4301-9a28-6f58ba30e5e9);}.uuid-1d99238e-3d91-47f7-b0d9-171d33d10fbc{fill:#bfbfbf;}.uuid-98e90f26-75a9-43f3-a18d-a71d8505c326{fill:#003b3f;}.uuid-88ecec94-885f-4c68-bf95-682b08cbe81d{fill:#7fcc97;}.uuid-3ef73bbf-f451-44f2-8e58-884c30a14015{isolation:isolate;}.uuid-3ef73bbf-f451-44f2-8e58-884c30a14015,.uuid-a7a745bb-141d-4f29-a5ae-133208f6b2cb,.uuid-e6e4d4ef-11a7-40f6-b53f-b8599ee8debc{fill:none;}.uuid-7aaa718d-7a30-4af2-8783-168dc34b3bb0{filter:url(#uuid-1181b5e6-a184-4fa8-a9c3-f50bde283315);}.uuid-a7a745bb-141d-4f29-a5ae-133208f6b2cb{mix-blend-mode:multiply;opacity:.75;}.uuid-e6e4d4ef-11a7-40f6-b53f-b8599ee8debc{mask:url(#uuid-4fec11e3-a4af-4a5c-9d00-df872cdd03e5);}"), /*#__PURE__*/React.createElement("filter", {
    id: "uuid-1181b5e6-a184-4fa8-a9c3-f50bde283315",
    x: -2.32,
    y: -2.55,
    width: 98,
    height: 98,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "uuid-4fec11e3-a4af-4a5c-9d00-df872cdd03e5",
    x: -2.32,
    y: -2.55,
    width: 98,
    height: 98,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-7aaa718d-7a30-4af2-8783-168dc34b3bb0"
  }, /*#__PURE__*/React.createElement("image", {
    width: 98,
    height: 98,
    transform: "translate(-2.32 -2.55)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAABiCAYAAACrpQYOAAAACXBIWXMAAAsSAAALEgHS3X78AAAGyklEQVR4nO2dCU8UTRCGi0NBEBWQIwiImAgh/MjvT5oYLjmU+0bx4jBP67vpnZ1dl935oBfqTSqDcWGlnq6q7hmzb5uZXZvrztXuCNJQZ7P/iqmpKevv77euri7r7Oy0jo4Oa2trC4F0bWVdX/9pGlyJi4sLu7y8tG/fvtnR0ZGtr683/ds1BOL169c2NDQUAIyMjNiLFy/syZMnAQYg2tvbSzBaHUQM4erqKsSvX7/s58+fdn5+bqenp7a7u2vHx8e2v79vHz9+bOh9bgQCAGNjY+E6PDxsAwMDIfr6+gKIx48fh6q4byAUWRBUxNevX0NVEAB59eqVbW5u2srKyo3ep24Qs7OzNj8/b+Pj4wGGKuLZs2fW09Nj3d3dAURcEXYPWpMgICDQkghgAOL79+92dnZWqgjy8/nzZxsdHQ1AVldX63qff4Jg9fPD3717Z2/evAnEqYbBwcESBKrh0aNHFdWA+HOrisRngagqmBPAAARAgEFeCBYpQVWQk6WlpeZAvH371ubm5mx6ejpAAEgMobe3N1QBQcLjSrjPAgRQVBk/fvwI3UHBzCTUKYDx4cOHxkBQCUCgJQFiYmIiDOYYAlVAK3poUpXzu7MI6QgAIfHkheBr8sMGhsUJvIWFhZuDYPUDgGCLylx4+fKlPX36NLwJlF1/BBht30m+AlCEKghVg5GbTapAM4FK0HCmEqDfyn3//xRJ1yKNz1OaK8wTIu/cUQGClsTuSDOBdkQlaDA/hBnQjMiP2pH9HfIMdubIycmJHRwc1AeC1Q+AeHdEO6ISHEL9YnZwvmKg6/AnENvb2xXnjLIeQzXo0Jbdono7urmAwSJmJ0VXobuQWyKrsuwyB7QPjndHPpgbEx2E7Ssw2M4KBt1mcnKy7GeWgYActyx0YtYW1dW4GNrAoE09f/68VB0s9FwQbFGhBQi1I92ycDUnFrMqg9xyZZHngtCJEHK6bQEIV/OKD34AAAZ5zgXBlosXEtCDog/oYsSsEAjNC2YxRwSplGkGMjB070g38FzFKK4KwWAMVIDQcVynwodyA++2RE41K9R5WPhSCQRJ1x1Uh1C8yKdgqOvEO9IyENlwFSeBUNch4hyXDYH78GgzZWW7TjyDq1aED+ripeTrzmwsz/YdKdt9HMQtqtb/bHEQichB3IHyqsJB3LKqbYIcRCJyEInIQSQiB5GIHEQichCJyEEkIgeRiBxEInIQichBJCIHkYgcRCJyEInIQSQiB5GIHEQichCJyEEkIgeRiBxEInIQichBJCIHkYgcRCJyEInIQSQiB5GIHEQichCJyEEkIgeRiBxEInIQichBJCIHkYgcRCJyEInIQdyy9An8+ohqyUHcgbIQzEGkIwdxi4ptcmKnFnMQd6PYxkAqA5E1NnIVK9kXCERuReQNEFexij2K+BT9qq0pr3e5ipNMomQoyDW3IkTMYRSvGIIMooAhlYGIy8ZnRLESCNmlYezBVSqBUKmobPImu6txyVklNhDEYaUChHxweDGlIyCuYiTzQCw18TfF4ib2NS2BAAIvVMkAxNtTMYqrgdwqYpVAHB4eBuNTykYwgONqXrHhE0FVACUXxNramu3s7ITeRenwDXyzt6fmxJxlQQsAuWWxV60IJHsuKiOG4Wpc2il9+fIl5JfcqvtUBbG3txc8mbED5sWCER88XPWLGStnXzoNi5wcY6+cNQUs8zXDexkfZrkxyoEWrwO8cfyD2+uXWhKVIK9rWj8QMATMqsJgjhdijI0XHSAAICtgrm5r8G8JAh2FzgKAra0t+/TpU5jFeXb8FSAoGRyhcIYiZPwk81M3ja0tciQIVAGrHwB0GwAAJE+5lovv378PdmgY2Mke2CKrebdRzpcObcwEKgEILOzl5eVgn4zTe55hLMLt77+8v5BllyxYss8quNb6GP6HIjm9M5Q1DxjKGshAwN2dWFxcrJqVqiDYaulkHT/Q0K2POOK7tQ8BjBZjvDXVPGDXCYSNjY0yCLXc3a2WwzuilCg39ryQJjA8ZZDTuuT2TvvSLJF/nZy7NE9aGY4WmToBi4+8xKdlQJCneC5glQyMWpUgkZ26brHOzMzY3NxccJ1lixu7+wIEEERsJigYFV4JLTDs4/ts2bYMBEKnZbpHdovKcGYwV5sJWdUNwv4aywIB+32BkCutqkMgZCqY9bRrpcpQJcTPagRCty0AQCUQHNbY+gMib4taSzcCIQmEqgHfTVqVjGZVEXnDvFVAxM9i4orQcxsd1gSAqqAiqIRG1BCIrKanp8PhTwe/ahBaVXFlEHqAxk4JAI0mP1YhIFzNy4/IKcjMfgN2VLCpsHQGrAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f801671d-40ef-4301-9a28-6f58ba30e5e9",
    x1: -224.54,
    y1: -822.73,
    x2: -211.89,
    y2: -822.73,
    gradientTransform: "translate(757.88 498.32) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f2f0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f1f0ed",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#c9e3ce",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a9d9b6",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#92d2a5",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#84cd9a",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7fcc97"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "uuid-3ef73bbf-f451-44f2-8e58-884c30a14015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-cd27c6ad-79c7-4ac5-9f6c-18ab16a3a759"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-35c35904-e07c-400a-96c1-2110f81066f7",
    width: 92.8,
    height: 92.8,
    rx: 18.55,
    ry: 18.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "uuid-e6e4d4ef-11a7-40f6-b53f-b8599ee8debc"
  }, /*#__PURE__*/React.createElement("g", {
    className: "uuid-a7a745bb-141d-4f29-a5ae-133208f6b2cb"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1d99238e-3d91-47f7-b0d9-171d33d10fbc",
    width: 92.8,
    height: 92.8,
    rx: 18.55,
    ry: 18.55
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c6b517c4-f947-453c-9c35-63b54d5b797d",
    points: "32.12 72.22 20.39 60.49 11.51 69.5 23.24 81.23 32.12 72.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-88ecec94-885f-4c68-bf95-682b08cbe81d",
    x: 30.26,
    y: 45.76,
    width: 16.59,
    height: 16.59,
    rx: 3.04,
    ry: 3.04,
    transform: "translate(-26.93 43.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-98e90f26-75a9-43f3-a18d-a71d8505c326",
    d: "m51.25,27.81h0c-2.46,2.46-3.43,6.06-2.52,9.42h0c.9,3.37,3.53,6,6.9,6.9h0c3.37.9,6.96-.06,9.42-2.52h0c2.46-2.46,3.43-6.06,2.52-9.42h0c-.9-3.37-3.53-6-6.9-6.9h0c-3.37-.9-6.96.06-9.42,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-88ecec94-885f-4c68-bf95-682b08cbe81d",
    d: "m81.28,44.51v11.91c0,.78-.64,1.42-1.42,1.42h-11.91c-1.27,0-1.9-1.53-1-2.42l11.91-11.91c.89-.89,2.42-.26,2.42,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-88ecec94-885f-4c68-bf95-682b08cbe81d",
    d: "m48.34,11.57h-11.91c-.78,0-1.42.64-1.42,1.42v11.91c0,1.27,1.53,1.9,2.42,1l11.91-11.91c.89-.89.26-2.42-1-2.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbsLacenIconApp);
export default __webpack_public_path__ + "static/media/cbs-lacen-icon-app.07bb663c15c300855bbe70cc050c90dd.svg";
export { ForwardRef as ReactComponent };